import styled from 'styled-components';
import { themeGet, is, isNot } from '../../theme/utils';
import { media } from '../../theme/media';

export type OvalProps = {
  isVisible?: boolean;
};

export const Oval = styled.a<OvalProps>`
  height: 50px;
  width: 50px;
  border: 1px solid ${themeGet.colors('desertStorm')};
  background-color: ${themeGet.colors('white')};
  color: ${themeGet.colors('swirl')};
  border-radius: 50%;
  padding: 12px;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.4);
  cursor: pointer;
  margin: ${themeGet.space(3)};
  margin-left: auto;
  -webkit-tap-highlight-color: transparent;

  ${media.from.lg`
    margin: ${themeGet.space(5)};
    margin-left: auto;
  `};

  transition: visibility 0s, opacity 0.3s linear;
  ${is('isVisible')`
    visibility: visible;
    opacity: 1;
  `};

  ${isNot('isVisible')`
    visibility: hidden;
    transition: visibility 0.3s, opacity 0.3s linear;
    opacity: 0;
  `};
`;

// On mobile safari button should not be positioned too low,
// or the first click will be hijacked by safari bottom drawer
export const LiftedUpOval = styled(Oval)`
  position: relative;
  bottom: 55px;
`;

export const BackToTopButtonLabel = styled.div`
  display: none;
  white-space: nowrap;
  transform: translate(-50%, -50%);
  position: relative;
  bottom: -25px;
  left: 50%;
  font-size: ${themeGet.fontSize(3)};
  font-family: ${themeGet.fonts('brand')};
  color: ${themeGet.colors('kilamanjaro')};

  ${media.from.lg`
    display: inline-block;
  `};
`;
